<template>
  <SGPRowComponent>    
    <SGPColComponent :cols="largura" v-for="dado in dados" :key="dado">
      <div>
        <strong>{{ dado.label }}</strong>
      </div>
      <div v-if="dado.type == 'html'" v-html="dado.value"></div>
      <div v-else-if="dado.type == 'centro_funcional'">
        <CentroFuncionalBadge :valor="dado.value" :area-tecnica="dado.areaTecnica" />
      </div>
      <div v-else>
        {{ dado.value }}
        <SGPIconComponent
          v-if="dado.event && dado.event === 'abrirModalcontatosPage'"
          icon="mdi-card-account-phone-outline"
          color="red"
          @click="abrirModalclienteContato"
          class="ml-2"
        />
      </div>
    </SGPColComponent>
  </SGPRowComponent>
</template>

<script>
import EventBus from '@/common/helpers/EventBus'
import CentroFuncionalBadge from '@/common/sgp-components/CentroFuncionalBadge.vue'

export default {
  name: 'DadosColunasComponent',
  components: {
    CentroFuncionalBadge
  },
  props: {
    largura: {
      type: [String, Number],
      required: false,
      default: 3
    },

    dados: {
      type: Array,
      required: true
    }
  },
  methods: {
    abrirModalclienteContato () {
      EventBus.$emit('abrirModalClientesContatos');
    }
  }
}
</script>